
import jquery from 'jquery'
import Popper from 'popper.js'

window.jQuery = jquery
window.$ = jquery
window.Popper = Popper
